<script>
    import { onMount } from "svelte";
    import { BackArrow } from "../../../Components/Common/index.svelte";

    import { apiMethods } from "../../../Services/index.svelte";

    export let updatePhase = () => {};
    export let personalDetails = {};

    const options = [
        {
            id: 1,
            text: "Recommended by a colleague or friend",
        },
        {
            id: 2,
            text: "Web search",
        },
        {
            id: 3,
            text: "Social media",
        },
        {
            id: 4,
            text: "Group chat of forum",
        },
        {
            id: 5,
            text: "Asked around",
        },
        {
            id: 6,
            text: "Other - please tell us",
        },
    ];

    const __MAX__TEXTAREA__LENGTH = 300;

    let isUpdatingHearAboutUs = false;

    let profile = {};

    onMount(() => {
        if (personalDetails.hasOwnProperty("profile"))
            profile = { ...personalDetails.profile };
    });

    const updateHearAboutUs = async () => {
        isUpdatingHearAboutUs = true;

        personalDetails.profile = { ...profile };

        await apiMethods.putMethod.updateDoctor(personalDetails);

        isUpdatingHearAboutUs = false;

        updatePhase(10);
    };

    const handleChangeOption = (id) => {
        if (profile.hearAboutUsId == id) return;

        profile.hearAboutUsId = id;

        if (id == 6) profile.hearAboutUs = "";
        else
            profile.hearAboutUs = options.find(
                (option) => option.id == id,
            )?.text;
    };

    const handleTextareaInput = (e) => {
        profile.hearAboutUs = e.target.value.slice(0, __MAX__TEXTAREA__LENGTH);
    };
</script>

<div class="flex w-full gap-x-4 items-center justify-start">
    <BackArrow backFunc={() => updatePhase(8)} />
    <p class="text-[32px] font-bold text-primary">Survey</p>
</div>

<p class="text-[20px] font-bold w-full">Where did you here about us</p>

<div class="flex flex-col flex-1 w-full items-center gap-y-4">
    {#each options as { id, text }}
        <div class="form-control w-full">
            <label
                class="flex flex-1 w-full items-center justify-start gap-x-2 label cursor-pointer"
            >
                <input
                    type="radio"
                    name="radio-10"
                    class="radio radio-primary"
                    bind:value={profile.hearAboutUsId}
                    on:change={() => handleChangeOption(id)}
                />
                <span class="label-text">{text}</span>
            </label>
        </div>
    {/each}

    {#if profile.hearAboutUsId == 6}
        <div class="flex flex-1 flex-col gap-y-1 w-full">
            <textarea
                class="textarea textarea-bordered w-full"
                rows="6"
                autocomplete="off"
                bind:value={profile.hearAboutUs}
                on:input={handleTextareaInput}
            />
            <p class="text-right">
                {profile.hearAboutUs?.length ?? 0} / {__MAX__TEXTAREA__LENGTH}
            </p>
        </div>
    {/if}

    <button
        class={`btn btn-secondary text-white btn-sm border-none w-full ${
            isUpdatingHearAboutUs ? "loading" : ""
        }`}
        disabled={!profile.hearAboutUsId || isUpdatingHearAboutUs}
        on:click|preventDefault={updateHearAboutUs}
    >
        Submit
    </button>
</div>
